<form [formGroup]="form" class="eidos-impersonate-user-dialog">
  <h1 class="eidos-impersonate-user-dialog-title">Impersonate user</h1>

  <div class="eidos-impersonate-user-dialog-content">

    <div class="field">
      <label>Utente to impersonate</label>
      <input type="text" formControlName="usernameToImpersonate" required>
      <span class="field-error" *ngIf="form.controls.usernameToImpersonate.invalid && form.controls.usernameToImpersonate.touched">
        Field must be filled
      </span>
    </div>

  </div>

  <div class="eidos-impersonate-user-dialog-actions">

    <button class="eidos-button eidos-button-normal eidos-button-cancel" type="button" (click)="onCancelClick()">Cancel</button>

    <button class="eidos-button eidos-button-normal eidos-button-success" type="submit" (click)="onSaveClick()" [disabled]="form.invalid">Submit</button>

  </div>
</form>
